import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  selectClubName,
  selectSettings,
} from "../../store/slices/settingsSlice";
import { useTheme } from "../../context/ThemeContext";
import { safeGetItem } from "@mediatechgroup/app-version";

const Footer: React.FC = () => {
  const location = useLocation();
  const [contactLines, setContactLines] = useState<any>(null);
  // HELPER
  const currentYear = new Date().getFullYear();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const xTenantId = pathParts[0] || null;
  safeGetItem("settings");
  const settings: any = useSelector(selectSettings);
  const club: any = useSelector(selectClubName);
  const { isDarkMode } = useTheme();
  const { facebook_link, instagram_link, x_link, footer_text } = settings || {};

  const links = [
    {
      href: facebook_link,
      label: "Facebook",
      icon: (
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      href: instagram_link,
      label: "Instagram",
      icon: (
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      href: x_link,
      label: "Twitter",
      icon: (
        <svg
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    if (settings) {
      // Only details the club has entered. A missing one is left out: the
      // footer used to show a made-up address, email and phone number.
      const lines = [settings?.contact_address, settings?.contact_email, settings?.contact_phone]
        .map((line) => (typeof line === "string" ? line.trim() : ""))
        .filter(Boolean);

      setContactLines(lines);
    }
  }, [settings]);

  return (
    <footer className={`${isDarkMode ? 'bg-gray-800' : 'bg-black'} text-white`}>
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <h3 className={`text-lg sm:text-xl font-semibold mb-4 ${isDarkMode ? 'text-gray-100' : 'text-white'}`}>
              {/* Just the club's name: "Riverside Gymnastics Academy Platform"
                  read as if the club were a software product (2026-10-10). */}
              {club || "Athletics Platform"}
            </h3>
            <p className={`text-sm sm:text-base mb-4 leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-300'}`}>
              {footer_text?.trim()
                ? footer_text
                : "Empowering athletics clubs with comprehensive management tools for programs, athletes, enrollments, and more."}
            </p>
            <div className="flex space-x-6">
              {links
                ?.filter((item) => !!item.href) // only show if link exists
                ?.map((item, idx) => (
                  <Link
                    key={idx}
                    to={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`p-2 rounded-full transition-all duration-200 ${
                      isDarkMode
                        ? 'text-gray-400 hover:text-gray-100 hover:bg-gray-700'
                        : 'text-gray-300 hover:text-white hover:bg-gray-700'
                    }`}
                  >
                    <span className="sr-only">{item.label}</span>
                    {item.icon}
                  </Link>
                ))}
            </div>
          </div>

          <div className="col-span-1">
            <h3 className={`text-lg sm:text-xl font-semibold mb-3 sm:mb-4 ${isDarkMode ? 'text-gray-100' : 'text-white'}`}>
              Quick Links
            </h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <Link
                  to={`/${xTenantId}/`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/programs`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/about`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/contact`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className={`text-lg sm:text-xl font-semibold mb-3 sm:mb-4 ${isDarkMode ? 'text-gray-100' : 'text-white'}`}>
              Resources
            </h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <Link
                  to={`/${xTenantId}/faq`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/privacy`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/terms`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to={`/${xTenantId}/support`}
                  className={`text-sm sm:text-base transition-colors duration-200 ${
                    isDarkMode ? 'text-gray-300 hover:text-gray-100' : 'text-gray-300 hover:text-white'
                  }`}
                >
                  Support
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            {contactLines?.length > 0 && (
            <h3 className={`text-lg sm:text-xl font-semibold mb-3 sm:mb-4 ${isDarkMode ? 'text-gray-100' : 'text-white'}`}>
              Contact Us
            </h3>
            )}
            <address className={`not-italic ${isDarkMode ? 'text-gray-300' : 'text-gray-300'}`}>
              {contactLines?.map((line: any, idx: any) => (
                <p
                  key={idx}
                  className="mb-2 text-sm sm:text-base leading-relaxed"
                >
                  {line}
                </p>
              ))}
            </address>
          </div>
        </div>

        {/* <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>
            &copy; {currentYear} {club + " " + "Platform"}. All rights reserved.
          </p>
        </div> */}
        <div className={`mt-6 sm:mt-8 pt-6 sm:pt-8 text-xs sm:text-sm ${
          isDarkMode ? 'border-t border-gray-700 text-gray-300' : 'border-t border-gray-700 text-gray-300'
        }`}>
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4 sm:gap-6">
            {/* Left aligned content - Copyright */}
            <div className="lg:flex lg:items-center text-left">
              <p className="text-xs sm:text-sm">
                &copy; {currentYear} ClubCentral.app{" "}
                {club?.toString().trim() ? `& ${club.toString().trim()}` : ""}.
                All rights reserved.
              </p>
            </div>

            {/* Center content - Policy Links (desktop) / Below copyright (mobile) */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 lg:gap-6 order-last lg:order-none">
              <Link
                to={`/${xTenantId}/privacy-policy`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                Privacy Policy
              </Link>
              <Link
                to={`/${xTenantId}/terms-of-service`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                Terms of Service
              </Link>
              <Link
                to={`/${xTenantId}/cookie-policy`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                Cookie Policy
              </Link>
              <Link
                to={`/${xTenantId}/eula`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                EULA
              </Link>
              <Link
                to={`/${xTenantId}/accessibility-policy`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                Accessibility Policy
              </Link>
            </div>

            {/* Right aligned content */}
            <div className="text-left lg:text-right">
              <Link
                to={`https://mediatech.group`}
                className={`transition-colors duration-200 text-xs sm:text-sm ${
                  isDarkMode ? 'hover:text-gray-100 hover:underline' : 'hover:underline'
                }`}
              >
                Media &amp; Technology Group, LLC
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
